import { firebaseAuth } from "../../../firebase/firebaseAuth";
import firestore from "../../../firebase/firestore";
import {
  disableUser,
  enableUser,
  addUser,
  updateUser,
} from "../../../services/users";
import {
  addPartnerFb,
  updatePartnerFb,
  addRecipient,
  updateRecipients,
} from "../../../services/partners";
import { addFareFb, updateFareFb } from "../../../services/fares";
import { addPlantsFb, updatePlantsFb } from "../../../services/powerplants";
import { addPlansFb, updatePlansFb } from "../../../services/plans";
import {
  addTabulationFb,
  updateTabulationFb,
} from "../../../services/tabulations";
import {
  addUtilityCompanyFb,
  updateUtilityCompanyFb,
} from "../../../services/utilityCompanies";
import {
  addCooperativeFb,
  updateCooperativeFb,
} from "../../../services/cooperatives";
import { addHolidayFb, updateHolidayFb } from "../../../services/holidays";
import {
  getRecipient,
  createRecipient,
  updateRecipient,
} from "../../../services/pagarmeLib";
import moment from "moment";

export default {
  resetFilter({ commit }) {
    commit("resetState");
  },

  async getUsersByParams({ state, commit }, params) {
    commit("setUsers", []);
    try {
      commit("setLoading", true);
      let userRef = firestore.collection("users");
      if (params) {
        if (params.email) {
          userRef = userRef.where("email", "==", params.email);
        } else if (params.groups && params.groups.length > 0) {
          userRef = userRef.where("group", "array-contains-any", params.groups);
        }
      } else {
        userRef = userRef.where("group", "not-in", ["customer", ""]);
      }
      return userRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach((change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                commit("pushUser", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.users.findIndex((i) => i.id === doc.id);
                commit("spliceUsers", { index, data });
                break;
              }
              case "removed": {
                state.users.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setUsers", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setUsers", []);
      console.error(err);
    }
  },

  async updateUserStatus({ commit }, data) {
    try {
      let userRef = firestore.collection("users");
      commit("setLoading", true);
      if (!data.customer_id) {
        console.error("Usuário a ser atualizado não foi informado");
        return false;
      } else if (!data.status) {
        console.error("Status a ser atualizado não foi informado");
        return false;
      }

      if (data.status === "canceled") {
        let disabled = await disableUser(data.customer_id);
        if (disabled.status === 200) {
          await userRef
            .doc(data.customer_id)
            .update({ status: data.status })
            .then(() => {
              commit("setLoading", false);
            })
            .catch((err) => {
              console.error(err);
              commit("setLoading", false);
            });
        } else {
          console.error(disabled);
          await commit("setLoading", false);
        }
      } else {
        let enable = await enableUser(data.customer_id);
        if (enable.status === 200) {
          await userRef
            .doc(data.customer_id)
            .update({ status: data.status })
            .then(() => {
              commit("setLoading", false);
            })
            .catch((err) => {
              console.error(err);
              commit("setLoading", false);
            });
        } else {
          console.error(enable);
          await commit("setLoading", false);
        }
      }
    } catch (err) {
      await commit("setLoading", false);
      console.error(err);
    }
  },

  async addUser({ commit, dispatch }, data) {
    return addUser(data)
      .then(async (user) => {
        if (user && user.data) {
          firebaseAuth
            .sendPasswordResetEmail(user.data.email)
            .then(() => {
              alert("email enviado para " + user.data.email);
            })
            .catch((err) => {
              alert("Erro ao enviar email para " + user.data.email);
              console.error(err);
            });
        }
        let params = {
          email: data.email,
        };
        dispatch("getUsersByParams", params);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async modifyUser({ commit }, data) {
    commit("setLoading", true);
    return updateUser(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getPartners({ state, commit }) {
    commit("setPartners", []);
    try {
      commit("setLoading", true);
      let partnerRef = firestore.collection("partners");
      return partnerRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach((change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                commit("pushPartner", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.partners.findIndex((i) => i.id === doc.id);
                commit("splicePartners", { index, data });
                break;
              }
              case "removed": {
                state.partners.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setPartners", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setPartners", []);
      console.error(err);
    }
  },

  async addFare({ commit }, data) {
    commit("setLoading", true);
    return addFareFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updateFare({ commit }, data) {
    commit("setLoading", true);
    return updateFareFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async addPartner({ commit }, data) {
    commit("setLoading", true);
    return addPartnerFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updatePartner({ commit }, data) {
    commit("setLoading", true);
    return updatePartnerFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getRecipientsByAccount({ commit }, accounts) {
    commit("setLoading", true);
    const recipients = [];

    if (accounts.length > 0) {
      for (const account of accounts) {
        recipients.push(await getRecipient(account));
      }
    }
    commit("setLoading", false);
    return recipients;
  },

  async getAllRecipients({ commit }) {
    commit("setRecipients", []);

    try {
      const collectionRef = firestore.collection("pagarme_recipients");
      const rawRecipients = await collectionRef.get();
      const recipients = rawRecipients.docs.map((item) => item.data());

      commit("setRecipients", recipients);
    } catch (error) {
      commit("setRecipients", []);
      console.error(error);
    }
  },

  addRecipient({ commit }, { data, partnerId, bankAccounts }) {
    commit("setLoading", true);
    const bank_account = {
      bank_code: data.bankAccountData.bankCode,
      agencia: data.bankAccountData.agency,
      agencia_dv: data.bankAccountData.agencyDv,
      type: data.bankAccountData.typeAccount ?? "conta_corrente",
      conta: data.bankAccountData.account,
      conta_dv: data.bankAccountData.accountDv,
      legal_name: data.bankAccountData.name,
      document_number: data.bankAccountData.docNumber,
    };
    if (
      !data.bankAccountData.agencyDv ||
      data.bankAccountData.agencyDv.trim() === ""
    )
      delete bank_account.agencia_dv;

    const pagarmeObject = {
      bank_account,
      transfer_interval: data.transferInterval,
      transfer_day: data.transferDay,
      transfer_enabled: true,
      mcc: "7394",
    };

    return createRecipient(pagarmeObject)
      .then(async (client) => {
        bankAccounts.push(client.id);
        await updatePartnerFb(partnerId, { bankAccounts });
        await addRecipient(client);
        commit("pushRecipient", client);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  changeRecipient({ commit }, { recipientId, data }) {
    commit("setLoading", true);
    const bank_account = {
      bank_code: data.bankAccountData.bankCode,
      agencia: data.bankAccountData.agency,
      agencia_dv: data.bankAccountData.agencyDv,
      type: data.bankAccountData.typeAccount ?? "conta_corrente",
      conta: data.bankAccountData.account,
      conta_dv: data.bankAccountData.accountDv,
      legal_name: data.bankAccountData.name,
      document_number: data.bankAccountData.docNumber,
    };
    if (
      !data.bankAccountData.agencyDv ||
      data.bankAccountData.agencyDv.trim() === ""
    )
      delete bank_account.agencia_dv;

    const pagarmeObject = {
      bank_account,
      transfer_interval: data.transferInterval,
      transfer_day: data.transferDay,
      transfer_enabled: true,
    };

    return updateRecipient(recipientId, pagarmeObject)
      .then(async (client) => {
        await updateRecipients(client);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  async updateRecipientsList({ state, commit }, { recipientId }) {
    const recipients = state.recipients;
    const recipient = (
      await firestore.collection("pagarme_recipients").doc(recipientId).get()
    ).data();

    for (let i = 0; i < recipients.length; i++) {
      if (recipients[i].id === recipientId) {
        recipients[i] = recipient;
        break;
      }
    }

    commit("setRecipients", recipients);
  },

  async checkContracts(context, plantId) {
    const collectionRef = firestore
      .collection("power_plants")
      .doc(plantId)
      .collection("contracts");

    return collectionRef.get().then((item) => {
      for (const contract of item.docs) {
        const _contract = contract.data();
        if (_contract.url || _contract.contract) {
          return true;
        }
      }
      return false;
    });
  },

  async getPvsystReport({ commit }, { id }) {
    commit("setLoading", true);

    try {
      const collectionRef = firestore
        .collection("power_plants")
        .doc(id)
        .collection("pvsyst_report");
      const item = await collectionRef.get();

      commit("setLoading", false);

      return item?.docs[0]?.data() || null;
    } catch (error) {
      commit("setLoading", false);
      console.error(error);
      return null;
    }
  },

  async getEnergyBill({ commit }, { id }) {
    commit("setLoading", true);

    try {
      const collectionRef = firestore
        .collection("TotalBilling")
        .doc(id)
        .collection("upload_file");
      const item = await collectionRef.get();

      commit("setLoading", false);

      return item?.docs[0]?.data() || null;
    } catch (error) {
      commit("setLoading", false);
      console.error(error);
      return null;
    }
  },

  async getPlants({ state, dispatch, commit }) {
    commit("setPlants", []);
    try {
      commit("setLoading", true);
      let partnerRef = firestore.collection("power_plants");
      return partnerRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };

                const hasContract = await dispatch("checkContracts", doc.id);
                data.hasContract = hasContract;

                // foi definido 999999 para os contratos que não tem data de vencimento ficarem no final da lista
                data.contract_due_date = 999999;
                if (data.contract_end) {
                  const today = moment(new Date());
                  const due_date = moment(data.contract_end.toDate());
                  data.contract_due_date = due_date.diff(today, "days");
                }
                commit("pushPlant", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };

                const hasContract = await dispatch("checkContracts", doc.id);
                data.hasContract = hasContract;

                // foi definido 999999 para os contratos que não tem data de vencimento ficarem no final da lista
                data.contract_due_date = 999999;
                if (data.contract_end) {
                  const today = moment(new Date());
                  const due_date = moment(data.contract_end.toDate());
                  data.contract_due_date = due_date.diff(today, "days");
                }

                const index = state.plants.findIndex(
                  (powerPlant) => powerPlant.id === doc.id,
                );
                commit("splicePlants", { index, data });
                break;
              }
              case "removed": {
                const newPlants = state.plants.filter(
                  (powerPlant) => powerPlant.id !== doc.id,
                );
                commit("setPlants", newPlants);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setLoading", false);
          await commit("setPlants", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setPlants", []);
      console.error(err);
    }
  },

  async getContracts({ commit }, plantId) {
    commit("setContracts", []);
    try {
      commit("setLoading", true);
      let contractsRef = firestore
        .collection("power_plants")
        .doc(plantId)
        .collection("contracts");
      return contractsRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach((change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                commit("pushContracts", data);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setContracts", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setContracts", []);
      console.error(err);
    }
  },

  async addPlants({ commit }, data) {
    commit("setLoading", true);
    return addPlantsFb(data.id, data)
      .then((res) => {
        commit("setLoading", false);
        console.log(res);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updatePlants({ commit }, data) {
    commit("setLoading", true);
    const id = data.power_plant_id;
    return updatePlantsFb(id, data)
      .then((res) => {
        commit("setLoading", false);
        console.log(res);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getSplits({ commit }, accounts) {
    commit("setLoading", true);
    commit("setSplits", []);

    const bankAccounts = accounts.map((account) => account.recipient_id);
    const splits = [];

    if (bankAccounts.length > 0) {
      for (const account of bankAccounts) {
        const recipient = await getRecipient(account);
        const split = {
          ...accounts[bankAccounts.indexOf(account)],
          ...recipient,
        };
        splits.push(split);
      }
    }

    commit("setSplits", splits);
    commit("setLoading", false);
  },

  async addSplit({ dispatch }, { powerPlantId, split, newSplit }) {
    split.push(newSplit);

    return updatePlantsFb(powerPlantId, { split })
      .then(() => {
        dispatch("getSplits", split);
      })
      .catch((err) => {
        console.error(err);
      });
  },

  async changeSplit({ state, commit }, { powerPlantId, recipientId, split }) {
    commit("SetLoading", true);

    return updatePlantsFb(powerPlantId, { split })
      .then(() => {
        const newSplits = state.splits.filter(
          (split) => split.id !== recipientId,
        );
        commit("setSplits", newSplits);
        commit("SetLoading", false);
      })
      .catch((err) => {
        console.error(err);
        commit("SetLoading", false);
      });
  },

  async getPlans({ state, commit }) {
    commit("setPlans", []);
    try {
      commit("setLoading", true);
      let partnerRef = firestore.collection("plans");
      return partnerRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach((change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                commit("pushPlan", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.plans.findIndex((i) => i.id === doc.id);
                commit("splicePlans", { index, data });
                break;
              }
              case "removed": {
                state.plans.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setPlans", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setPlans", []);
      console.error(err);
    }
  },

  async addPlans({ commit }, data) {
    commit("setLoading", true);
    return addPlansFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updatePlans({ commit }, data) {
    commit("setLoading", true);
    let id = data.id;
    delete data.id;
    console.log("data: ", data);
    return updatePlansFb(id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async loadBanks({ commit }) {
    try {
      const response = await fetch(
        "https://gist.github.com/antoniopresto/d73888dab087ae35a7cf41a61d8a3cbc.js",
      );
      commit("setBanks", response.data);
    } catch (error) {
      console.error(error);
    }
  },

  selectPartner({ commit }, data) {
    commit("setPartner", data);
  },

  selectUser({ commit }, data) {
    commit("setUser", data);
  },

  async getTabulations({ state, commit }) {
    commit("setTabulations", []);
    try {
      commit("setLoading", true);
      let partnerRef = firestore.collection("tabulations");
      return partnerRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach((change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                commit("pushTabulations", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.tabulations.findIndex(
                  (i) => i.id === doc.id,
                );
                commit("spliceTabulations", { index, data });
                break;
              }
              case "removed": {
                state.tabulations.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setTabulations", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setTabulations", []);
      console.error(err);
    }
  },

  async addTabulation({ commit }, data) {
    commit("setLoading", true);
    return addTabulationFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updateTabulation({ commit }, data) {
    commit("setLoading", true);
    const id = data.id;
    delete data.id;
    delete data.status;
    console.log("data: ", data);
    return updateTabulationFb(id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getUrlShortners({ state, commit }, filter) {
    commit("setUrlShortners", []);
    try {
      commit("setLoading", true);
      let urlShortnerRef = firestore.collection("url_shortner");
      let query = urlShortnerRef;
      console.log("filter: ", filter);
      if (filter.urlCode) query = query.where("urlCode", "==", filter.urlCode);
      else {
        if (filter.start_date)
          query = query.where("created_at", ">=", filter.start_date);
        if (filter.end_date)
          query = query.where("created_at", "<=", filter.end_date);
      }
      return query
        .limit(100)
        .orderBy("created_at", "desc")
        .onSnapshot(async (res) => {
          console.log("size: ", res.size);
          if (res.size > 0) {
            const changes = res.docChanges();
            changes.forEach((change) => {
              const { doc } = change;
              console.log("type: ", change.type);
              switch (change.type) {
                case "added": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  commit("pushUrlShortners", data);
                  break;
                }
                case "modified": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  const index = state.urlShortners.findIndex(
                    (i) => i.id === doc.id,
                  );
                  commit("spliceUrlShortners", { index, data });
                  break;
                }
                case "removed": {
                  state.urlShortners.filter((i) => i.id !== doc.id);
                  break;
                }
                default:
                  break;
              }
            });
            await commit("setLoading", false);
            return true;
          } else {
            await commit("seturlShortners", []);
          }
          await commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("seturlShortner", []);
      console.error(err);
    }
  },

  async getUtilityCompanies({ state, commit }, args) {
    await commit("setUtilityCompanies", []);
    let correiosUtilities = ["cemig", "neoenergia-pe", "neoenergia-ba"];
    try {
      await commit("setLoading", true);
      let utilityCompaniesRef = firestore.collection("utility_companies");
      if (args?.onlyActivated)
        utilityCompaniesRef = utilityCompaniesRef.where(
          "status",
          "==",
          "activated",
        );
      return utilityCompaniesRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                if (origin == "correios") {
                  if (correiosUtilities.includes(data.id))
                    await commit("pushUtilityCompany", data);
                } else await commit("pushUtilityCompany", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.utilityCompanies.findIndex(
                  (i) => i.id === doc.id,
                );
                await commit("spliceUtilityCompanies", { index, data });
                break;
              }
              case "removed": {
                state.utilityCompanies.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setUtilityCompanies", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setUtilityCompanies", []);
      console.error(err);
    }
  },

  async getUtilityCompaniesByState({ state, commit }, estado) {
    await commit("setUtilityCompanies", []);
    try {
      await commit("setLoading", true);
      let utilityCompaniesRef = firestore.collection("utility_companies");
      return utilityCompaniesRef
        .where("state", "==", estado)
        .onSnapshot(async (res) => {
          if (res.size > 0) {
            const changes = res.docChanges();
            changes.forEach(async (change) => {
              const { doc } = change;
              switch (change.type) {
                case "added": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  await commit("pushUtilityCompany", data);
                  break;
                }
                case "modified": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  const index = state.utilityCompanies.findIndex(
                    (i) => i.id === doc.id,
                  );
                  await commit("spliceUtilityCompanies", { index, data });
                  break;
                }
                case "removed": {
                  state.utilityCompanies.filter((i) => i.id !== doc.id);
                  break;
                }
                default:
                  break;
              }
            });
            await commit("setLoading", false);
            return true;
          } else {
            await commit("setUtilityCompanies", []);
          }
          await commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setUtilityCompanies", []);
      console.error(err);
    }
  },

  async addUtilityCompany({ commit }, data) {
    await commit("setLoading", true);
    return addUtilityCompanyFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updateUtilityCompany({ commit }, data) {
    await commit("setLoading", true);
    const id = data.id;
    delete data.id;
    return updateUtilityCompanyFb(id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getCooperatives({ state, commit }) {
    await commit("setCooperatives", []);
    try {
      await commit("setLoading", true);
      let cooperativesRef = firestore.collection("cooperatives");
      return cooperativesRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                await commit("pushCooperative", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.cooperatives.findIndex(
                  (i) => i.id === doc.id,
                );
                await commit("spliceCooperatives", { index, data });
                break;
              }
              case "removed": {
                state.cooperatives.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setCooperatives", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setCooperatives", []);
      console.error(err);
    }
  },

  async addCooperative({ commit }, data) {
    await commit("setLoading", true);
    return addCooperativeFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updateCooperative({ commit }, data) {
    await commit("setLoading", true);
    const id = data.id;
    delete data.id;
    return updateCooperativeFb(id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getHolidays({ state, commit }) {
    await commit("setHolidays", []);
    try {
      await commit("setLoading", true);
      let holidaysRef = firestore.collection("holidays");
      return holidaysRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                await commit("pushHoliday", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.holidays.findIndex((i) => i.id === doc.id);
                await commit("spliceHolidays", { index, data });
                break;
              }
              case "removed": {
                let new_holidays = state.holidays.filter(
                  (i) => i.id !== doc.id,
                );
                await commit("setHolidays", new_holidays);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setHolidays", []);
        }
        await commit("setLoading", false);
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setHolidays", []);
      console.error(err);
    }
  },

  async addHoliday({ commit }, data) {
    await commit("setLoading", true);
    return addHolidayFb(data.id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async updateHoliday({ commit }, data) {
    await commit("setLoading", true);
    const id = data.id;
    delete data.id;
    return updateHolidayFb(id, data)
      .then(() => {
        commit("setLoading", false);
      })
      .catch((err) => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  async getDocuments({ commit }, powerplant_id) {
    commit("setDocuments", []);
    const documents = [];
    try {
      commit("setLoading", true);
      await firestore
        .collection("power_plants")
        .doc(powerplant_id)
        .collection("documents")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            documents.push(doc.data());
          });
        });

      commit("setLoading", false);
      if (documents.length > 0) {
        commit("setDocuments", documents);
      } else {
        commit("setDocuments", []);
      }
      return documents;
    } catch (err) {
      console.error(err);
      commit("setLoading", false);
    }
  },

  async getDocumentsCompetence({ commit }, args) {
    commit("setDocuments", []);
    const documents = [];
    try {
      commit("setLoading", true);
      await firestore
        .collection("TotalBilling")
        .doc(`${args.power_plant_id}-${args.newCompetence}`)
        .collection("upload_file")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (!documents.find((item) => item.name === doc.data().name))
              documents.push(doc.data());
          });
        });
      commit("setLoading", false);
      if (documents.length > 0) {
        commit("setDocuments", documents);
      } else {
        commit("setDocuments", []);
      }
      return documents;
    } catch (err) {
      console.error(err);
      commit("setLoading", false);
    }
  },
};
